'use client';

import { KEYS } from 'platejs';
import { BlockPlaceholderPlugin } from 'platejs/react';

import { RICH_TEXT_FOCUSED_PLACEHOLDER } from '@/lib/rich-text-empty-state';

/** Per-block placeholder on focused empty paragraphs (e.g. after Enter). */
export const FieldBlockPlaceholderKit = [
  BlockPlaceholderPlugin.configure({
    options: {
      className:
        'before:pointer-events-none before:absolute before:top-1/2 before:-translate-y-1/2 before:cursor-text before:text-muted-foreground/80 before:opacity-100 before:content-[attr(placeholder)]',
      placeholders: {
        [KEYS.p]: RICH_TEXT_FOCUSED_PLACEHOLDER,
      },
      query: ({ path }) => path.length === 1,
    },
  }),
];
